import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LineMarginViolation,
  OrderMarginViolation
} from '../../services/margin-validation.service';
import {
  MARGIN_APPROVAL_THRESHOLD_MESSAGE,
  MARGIN_BLOCKED_THRESHOLD_MESSAGE,
  MARGIN_ITEM_WARNING_MESSAGE,
  MARGIN_ITEM_WARNING_NOTE
} from '../margin-approval.utils';

@Component({
  selector: 'app-margin-approval-dialog-content',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './margin-approval-dialog-content.component.html'
})
export class MarginApprovalDialogContentComponent {
  @Input() mode: 'item-warning' | 'approval' | 'blocked' = 'approval';
  @Input() itemName = '';
  @Input() actualMargin = 0;
  @Input() requiredMargin = 0;
  @Input() failingLines: LineMarginViolation[] = [];
  @Input() orderViolation: OrderMarginViolation | null = null;
  @Input() note = '';
  @Input() proceedNote = '';
  @Input() contactEmails: string[] = [];
  @Input() proceedActionLabel = 'Approve & Save Draft';
  @Input() blockedApprovalNotice = '';

  readonly itemWarningMessage = MARGIN_ITEM_WARNING_MESSAGE;
  readonly itemWarningNote = MARGIN_ITEM_WARNING_NOTE;
  readonly blockedThresholdMessage = MARGIN_BLOCKED_THRESHOLD_MESSAGE;
  readonly approvalThresholdMessage = MARGIN_APPROVAL_THRESHOLD_MESSAGE;
}
